export * from './circular-progress.module';

export * from './circular-progress.component';
